import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = window.ResizeObserver || Polyfill;

class DataSizesFix {

    constructor(el) {
        // store element
        this.el = el;
        this.width = 0;
        this.timeout = null;
        let pictureImage = this.el.querySelector('img');
        this.isPicture = pictureImage;
        this.img = this.isPicture ? pictureImage : this.el;
        this.sources = this.isPicture ? this.el.querySelectorAll('source') : null;
        // add resizeObserver
        this.ro = new ResizeObserver(entries => {
            for (let entry of entries) {
                const cr = entry.contentRect;
                let w = Math.ceil(cr.width);
                if(w != this.width) {
                    this.width = w;
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.update();
                    }, 50);
                }
            }
        });
        this.ro.observe(this.img);
    }

    update() {
        this.img.setAttribute('sizes',`${this.width}px`);
        if(this.isPicture && this.sources.length > 0) this.sources.forEach(s => {
            s.setAttribute('sizes',`${this.width}px`);
        });
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new DataSizesFix(node);
        }
    });
}